// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fDXmzueKdaJlQeA7eX22 {
	align-items: center;
	display: flex;
	gap: 4px;
}
.IpwXzCuhZHWwGxIteB3r {
	flex: 1;
	height: 36px;
}
@media (max-width: 767px) {
.IpwXzCuhZHWwGxIteB3r {
		height: 40px;
}
	}
`, "",{"version":3,"sources":["webpack://./src/components/ExpiresDate/SimpleMode.pcss"],"names":[],"mappings":"AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,QAAQ;AACT;AAEA;CACC,OAAO;CACP,YAAY;AAKb;AAHC;AAJD;EAKE,YAAY;AAEd;CADC","sourcesContent":["@import './../../stylesheets/media-queries.pcss';\n\n.container {\n\talign-items: center;\n\tdisplay: flex;\n\tgap: 4px;\n}\n\n.button {\n\tflex: 1;\n\theight: 36px;\n\n\t@media (--mobile) {\n\t\theight: 40px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `fDXmzueKdaJlQeA7eX22`,
	"button": `IpwXzCuhZHWwGxIteB3r`
};
export default ___CSS_LOADER_EXPORT___;
